module.exports = __webpack_public_path__ + "img/pizzaset-658.b0917cef.png";